import AccountSettings from "./AccountSettings";
import { connect } from "react-redux";
import { editCostLimit, fetchCostLimits } from "./actions/costLimits";
import {
  editAccountSettings,
  fetchAccountSettings,
  createAccountSettings,
  newAccountSettings,
  cancelEditAccountSettings,
  clearAccountSettings
} from "./actions/accountSettings";

const mapStateToProps = state => ({
  costLimits: state.entities.costLimits,
  loadingCostLimits: state.ui.loadingCostLimits,
  accountSettings: state.entities.accountSettings,
  loadingAccountSettings: state.ui.loadingAccountSettings
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchCostLimits() {
      const filters = {
        accountId: ownProps.account.id
      };
      dispatch(fetchCostLimits({ filters }));
    },
    editCostLimit(id) {
      dispatch(editCostLimit(id));
    },
    fetchAccountSettings() {
      dispatch(fetchAccountSettings(ownProps.account.id));
    },
    editAccountSettings(id) {
      dispatch(editAccountSettings(id));
    },
    newAccountSettings(accountId) {
      dispatch(newAccountSettings(accountId));
    },
    createAccountSettings(accountId) {
      dispatch(createAccountSettings(accountId));
    },
    clearAccountSettings() {
      dispatch(cancelEditAccountSettings());
      dispatch(clearAccountSettings());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);



// WEBPACK FOOTER //
// ./src/AccountSettingsContainer.js